/* GWP listicle landing page: offer card selection, option pills, sticky CTA, smooth anchor scroll. */
(function () {
  "use strict";

  if (window.__gwpLandingLoaded) return;
  window.__gwpLandingLoaded = true;

  var TELEMETRY_ENDPOINT = "https://zernio-dm-throttler.holistic-wellness-ebooks.workers.dev/api/shopify/storefront-events";
  var TOKEN_PATTERN = /^[a-z0-9][a-z0-9_-]{0,79}$/;
  var ACCOUNT_ID_PATTERN = /^[0-9a-f]{24}$/;
  var NUMERIC_ID_PATTERN = /^[1-9][0-9]{0,19}$/;
  var SKU_PATTERN = /^[A-Z0-9-]{1,100}$/;
  var PLATFORMS = ["facebook", "instagram"];

  function telemetryContext() {
    var params = new URLSearchParams(window.location.search);
    function single(key) {
      var values = params.getAll(key);
      return values.length === 1 ? values[0] : "";
    }
    function optionalToken(key) {
      var value = single(key).toLowerCase();
      return TOKEN_PATTERN.test(value) ? value : "";
    }
    var accountId = single("zernio_account_id").toLowerCase();
    var platform = single("utm_source").toLowerCase();
    if (!ACCOUNT_ID_PATTERN.test(accountId) || PLATFORMS.indexOf(platform) === -1
      || !window.crypto || typeof window.crypto.randomUUID !== "function") return null;
    return {
      accountId: accountId,
      platform: platform,
      campaign: optionalToken("utm_campaign"),
      landingVariantId: optionalToken("landing_variant_id"),
      creativeAngleId: optionalToken("creative_angle_id")
    };
  }

  function sendTelemetry(context, cta, eventType, ctaPosition) {
    if (!context || !cta) return;
    var productId = cta.getAttribute("data-product-id") || "";
    var variantId = cta.getAttribute("data-variant-id") || "";
    var sku = cta.getAttribute("data-sku") || "";
    if (!NUMERIC_ID_PATTERN.test(productId) || !NUMERIC_ID_PATTERN.test(variantId)
      || !SKU_PATTERN.test(sku)) return;
    var body = {
      eventId: window.crypto.randomUUID(),
      eventType: eventType,
      productId: productId,
      variantId: variantId,
      sku: sku,
      accountId: context.accountId,
      platform: context.platform
    };
    if (context.campaign) body.campaign = context.campaign;
    if (context.landingVariantId) body.landingVariantId = context.landingVariantId;
    if (context.creativeAngleId) body.creativeAngleId = context.creativeAngleId;
    if (ctaPosition) body.ctaPosition = ctaPosition;
    try {
      var pending = window.fetch(TELEMETRY_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        mode: "cors",
        credentials: "omit",
        referrerPolicy: "no-referrer",
        keepalive: true
      });
      if (pending && typeof pending.catch === "function") pending.catch(function () {});
    } catch (_error) {
      // Telemetry must never delay or interrupt checkout.
    }
  }

  function initOfferBox(box) {
    if (box.dataset.gwpOfferReady === "true") return;
    box.dataset.gwpOfferReady = "true";
    var plans = Array.prototype.slice.call(box.querySelectorAll("[data-gwp-plan]"));
    var cta = box.querySelector("[data-gwp-cta]");
    var shortcuts = Array.prototype.slice.call(document.querySelectorAll('.gwp-scope a.gwp-btn[href="#offers"], .gwp-scope a.gwp-btn[data-gwp-checkout-shortcut]'));
    shortcuts = shortcuts.filter(function (link) { return link !== cta; });

    function syncPurchaseLinks() {
      if (!cta) return;
      var href = cta.getAttribute("href") || "";
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/[1-9][0-9]*:1(?:,[1-9][0-9]*:1)*(?:\?[^#]*)?$/.test(href)) return;
      shortcuts.forEach(function (link) {
        link.setAttribute("href", href);
        link.setAttribute("data-gwp-checkout-shortcut", "");
        ["data-product-id", "data-variant-id", "data-sku"].forEach(function (key) {
          link.setAttribute(key, cta.getAttribute(key) || "");
        });
      });
    }
    var options = Array.prototype.slice.call(box.querySelectorAll("[data-gwp-option]"));
    var discount = box.getAttribute("data-gwp-discount") || "";
    var cartPath = box.getAttribute("data-gwp-cart-path") || "/cart/";
    var giftVariantIds = (box.getAttribute("data-gwp-gift-variant-ids") || "")
      .split(",")
      .map(function (id) { return id.trim(); })
      .filter(Boolean);

    function cartUrl(variantId) {
      // Checkout displays cart permalink lines in reverse insertion order.
      // Insert gifts first so the selected main product is visible first.
      var lineIds = giftVariantIds.concat([variantId]);
      var url = cartPath + lineIds.map(function (id) { return id + ":1"; }).join(",");
      if (discount) {
        url += "?discount=" + encodeURIComponent(discount);
      }
      return url;
    }

    function selectPlan(plan) {
      plans.forEach(function (candidate) {
        candidate.setAttribute("aria-checked", candidate === plan ? "true" : "false");
      });
      if (cta && plan.getAttribute("data-variant-id")) {
        cta.setAttribute("href", cartUrl(plan.getAttribute("data-variant-id")));
        cta.setAttribute("data-product-id", plan.getAttribute("data-product-id") || "");
        cta.setAttribute("data-variant-id", plan.getAttribute("data-variant-id") || "");
        cta.setAttribute("data-sku", plan.getAttribute("data-sku") || "");
        syncPurchaseLinks();
      }
    }

    plans.forEach(function (plan) {
      plan.addEventListener("click", function () {
        selectPlan(plan);
      });
    });

    options.forEach(function (option) {
      option.addEventListener("click", function () {
        options.forEach(function (candidate) {
          candidate.setAttribute("aria-pressed", candidate === option ? "true" : "false");
        });
        var target = option.getAttribute("data-gwp-option-target");
        if (target) {
          var plan = box.querySelector('[data-gwp-plan][data-variant-title="' + target + '"]');
          if (plan) {
            selectPlan(plan);
          }
        }
      });
    });

    if (plans.length > 0) {
      var preselected = box.querySelector('[data-gwp-plan][aria-checked="true"]') || plans[0];
      selectPlan(preselected);
    }
    syncPurchaseLinks();

    var context = telemetryContext();
    if (!context || !cta) return;
    sendTelemetry(context, cta, "page_view");
    if (typeof window.IntersectionObserver === "function") {
      var observer = new window.IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        sendTelemetry(context, cta, "cta_impression", "checkout");
        observer.disconnect();
      }, { threshold: 0.25 });
      observer.observe(cta);
    }
    [cta].concat(shortcuts).forEach(function (link) {
      var opened = false;
      link.addEventListener("click", function () {
        if (opened) return;
        opened = true;
        sendTelemetry(context, cta, "cta_click", "checkout");
        sendTelemetry(context, cta, "checkout_exposure", "checkout");
      }, { capture: true });
    });
  }

  function initStickyCta(sticky) {
    if (sticky.dataset.gwpStickyReady === "true") return;
    sticky.dataset.gwpStickyReady = "true";
    var threshold = parseInt(sticky.getAttribute("data-gwp-sticky-after") || "600", 10);

    if (threshold === 0) {
      var regularCtas = Array.prototype.slice.call(document.querySelectorAll(
        '[data-cta-position], [data-gwp-cta], [data-sticky-cta-guard], a[href="#offers"]'
      )).filter(function (cta) {
        return !sticky.contains(cta);
      });

      function isVisibleInViewport(cta) {
        var styles = window.getComputedStyle(cta);
        if (styles.display === "none" || styles.visibility === "hidden") return false;
        var rect = cta.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.bottom > 0 &&
          rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
      }

      function updateForViewport() {
        var otherCtaVisible = regularCtas.some(isVisibleInViewport);
        sticky.classList.toggle("is-visible", !otherCtaVisible);
        sticky.setAttribute("aria-hidden", otherCtaVisible ? "true" : "false");
      }

      updateForViewport();

      if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(updateForViewport, { threshold: 0.01 });
        regularCtas.forEach(function (cta) { observer.observe(cta); });
      } else {
        window.addEventListener("scroll", updateForViewport, { passive: true });
      }
      window.addEventListener("resize", updateForViewport, { passive: true });
      return;
    }

    var visible = false;

    function onScroll() {
      var shouldShow = window.scrollY > threshold;
      if (shouldShow !== visible) {
        visible = shouldShow;
        sticky.classList.toggle("is-visible", visible);
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  function initAnchorScroll(scope) {
    var links = scope.querySelectorAll('a[href^="#"]');
    Array.prototype.forEach.call(links, function (link) {
      if (link.dataset.gwpAnchorReady === "true") return;
      link.dataset.gwpAnchorReady = "true";
      link.addEventListener("click", function (event) {
        var id = link.getAttribute("href").slice(1);
        var target = id && document.getElementById(id);
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? "instant" : "smooth", block: id === "offers" ? "center" : "start" });
        }
      });
    });
  }

  function init() {
    var boxes = document.querySelectorAll("[data-gwp-offer-box]");
    Array.prototype.forEach.call(boxes, initOfferBox);

    var stickies = document.querySelectorAll("[data-gwp-sticky]");
    Array.prototype.forEach.call(stickies, initStickyCta);

    var scopes = document.querySelectorAll(".gwp-scope");
    Array.prototype.forEach.call(scopes, initAnchorScroll);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);

  /* On-page arrival beacon (Hugo 2026-09-27): DM and bio arrivals are counted on the page instead of by a
     redirect. One cookieless text/plain event per fresh navigation, sent after load (never before the LCP
     work), on pagehide or when the page is hidden, whichever comes first. No cookies, no storage, no
     full URL, no user agent. Separate from the DM telemetry above and can never affect checkout links.

     Load-loss measurement (Hugo 2026-09-27), DM arrivals only (same DM test as the v1 body):
     - the DM arrival goes out at the v1 moment (load + idle, the same call as before this change, so an
       in-app browser closed soon after load still sends it), with the load fields known at that moment,
       or earlier on pagehide / hidden (then left:true). One arrival per page load (lid). Bio and other
       arrivals keep the v1 body.
     - the DM arrival stays wire-compatible: v:1 plus kind:"arrival", lid (16 random hex chars, memory
       only), stage (dcl|hero|load reached), t (ms since navigation start: ttfb, fcp, hero, dcl, load),
       left and nav. A worker that only knows v1 ignores the extra keys and counts the DM click as
       before, so theme and worker can ship or roll back in either order. All v1 fields are kept; if the
       extension does not fit the size cap the plain v1 body is sent instead.
     - kind:"tap" (v:2): first buy-link tap per page load (capture phase, sendBeacon, never delays the
       tap): lid, ms, target (hero|offer|sticky|other) and the arrival's DM ids. Before load a still
       pending arrival goes out in the same tap (left:true), because WebKit fires no pagehide for a page
       that is left before load; its tap row (same lid) tells a checkout departure from an abandonment.
     - kind:"return" (v:2): the page came back from the back/forward cache after a tap (lid, sinceTapMs);
       re-arms the tap so a second checkout attempt is counted.
     Taps and returns are v:2 so a worker that only knows v1 drops them: they never count as arrivals.
     Nothing runs in <head> and nothing is sent before load unless the visitor hides or leaves. */
  (function arrivalBeacon() {
    var ARRIVAL_ENDPOINT = "https://zernio-dm-throttler.holistic-wellness-ebooks.workers.dev/api/landing/arrival";
    var MAX_BODY_LENGTH = 1024;
    var TAP_SELECTOR = 'a[href*="/cart/"], a[data-gwp-cta], a[data-gwp-checkout-shortcut]';
    var V2_FIELDS = ["kind", "lid", "stage", "t", "left", "nav"];
    var TAP_FIELDS = ["platform", "acct", "camp", "evt", "zsig"];
    var VALUE_PATTERN = /^[a-z0-9][a-z0-9_.:-]{0,79}$/i;
    // Same bound as the ConnectionQueue accepts for an event id (1-200 chars), so no signed DM click is lost.
    var EVENT_ID_PATTERN = /^[a-z0-9][a-z0-9_.:-]{0,199}$/i;
    var SIGNATURE_PATTERN = /^[0-9a-f]{64}$/;
    var LOCALE_PATTERN = /^[a-z]{2}(?:-[a-z0-9]{2,4})?$/i;
    var HOST_PATTERN = /^[a-z0-9.-]{1,100}$/;
    var BIO_SOURCES = { "ig-bio": "instagram", "fb-bio": "facebook", "bio-link": "" };
    var sent = false;
    var identity = null;
    // DM load-loss state, memory only: lid "" = not decided yet, null = not a DM page.
    var lid = "";
    var dmBody = null;
    var tapAt = 0;
    var prerendered = false;

    function queryValue(params, key, keepCase, pattern) {
      var values = params.getAll(key);
      if (values.length !== 1) return "";
      var value = keepCase ? values[0] : values[0].toLowerCase();
      return (pattern || VALUE_PATTERN).test(value) ? value : "";
    }

    function captureIdentity() {
      if (identity) return identity;
      var cta = document.querySelector("[data-gwp-offer-box] [data-gwp-cta]") || document.querySelector("[data-gwp-cta]");
      if (!cta) return null;
      var productId = cta.getAttribute("data-product-id") || "";
      var variantId = cta.getAttribute("data-variant-id") || "";
      var sku = cta.getAttribute("data-sku") || "";
      if (!NUMERIC_ID_PATTERN.test(productId) || !NUMERIC_ID_PATTERN.test(variantId)
        || !SKU_PATTERN.test(sku)) return null;
      identity = { pid: productId, vid: variantId, sku: sku };
      return identity;
    }

    function referrerHost() {
      if (!document.referrer || typeof window.URL !== "function") return "";
      try {
        var host = new window.URL(document.referrer).hostname.toLowerCase();
        return HOST_PATTERN.test(host) ? host : "";
      } catch (_error) {
        return "";
      }
    }

    function referrerPlatform(host) {
      if (/(^|\.)instagram\.com$/.test(host) || host === "com.instagram.android") return "instagram";
      if (/(^|\.)(facebook\.com|fb\.com|fb\.me|messenger\.com)$/.test(host)
        || /^com\.facebook\.(katana|orca|lite)$/.test(host)) return "facebook";
      return "";
    }

    function randomId() {
      var cryptoApi = window.crypto;
      if (cryptoApi && typeof cryptoApi.randomUUID === "function") return cryptoApi.randomUUID();
      var bytes = [];
      var i;
      if (cryptoApi && typeof cryptoApi.getRandomValues === "function" && typeof window.Uint8Array === "function") {
        var buffer = new window.Uint8Array(16);
        cryptoApi.getRandomValues(buffer);
        for (i = 0; i < 16; i++) bytes.push(buffer[i]);
      } else {
        for (i = 0; i < 16; i++) bytes.push(Math.floor(Math.random() * 256));
      }
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      var hex = "";
      for (i = 0; i < 16; i++) {
        hex += (bytes[i] < 16 ? "0" : "") + bytes[i].toString(16);
        if (i === 3 || i === 5 || i === 7 || i === 9) hex += "-";
      }
      return hex;
    }

    function pageLocale() {
      var shopify = window.Shopify;
      var locale = (shopify && typeof shopify.locale === "string" && shopify.locale)
        || document.documentElement.getAttribute("lang") || "";
      return LOCALE_PATTERN.test(locale) ? locale.toLowerCase() : "";
    }

    function buildBody() {
      var params = new window.URLSearchParams(window.location.search);
      var utmSource = queryValue(params, "utm_source");
      var utmMedium = queryValue(params, "utm_medium");
      var utmCampaign = queryValue(params, "utm_campaign");
      var utmContent = queryValue(params, "utm_content");
      var src = queryValue(params, "src");
      var accountId = queryValue(params, "zernio_account_id");
      var eventId = queryValue(params, "zernio_event_id", true, EVENT_ID_PATTERN);
      var signature = queryValue(params, "zsig");
      var signed = Boolean(eventId) && SIGNATURE_PATTERN.test(signature);
      // A DM that still passed the old bio hop has lost zernio_account_id but keeps utm_content=<account id>.
      if (!ACCOUNT_ID_PATTERN.test(accountId) && utmMedium === "comment-dm" && ACCOUNT_ID_PATTERN.test(utmContent)) {
        accountId = utmContent;
      }
      var ref = referrerHost();
      var channel = "other";
      var platform = "";
      // A valid signed event is a DM even when an app duplicated utm_medium (duplicates read as empty).
      if (ACCOUNT_ID_PATTERN.test(accountId) && (utmMedium === "comment-dm" || signed)) {
        channel = "dm";
        platform = PLATFORMS.indexOf(utmSource) !== -1 ? utmSource : referrerPlatform(ref);
      } else if (Object.prototype.hasOwnProperty.call(BIO_SOURCES, src) || utmContent === "link_in_bio") {
        channel = "bio";
        platform = BIO_SOURCES[src] || (utmContent === "link_in_bio" ? "instagram" : "") || referrerPlatform(ref);
      } else {
        platform = referrerPlatform(ref);
      }
      var page = captureIdentity();
      var body = { v: 1, id: randomId(), path: window.location.pathname.slice(0, 200), ch: channel };
      var locale = pageLocale();
      if (locale) body.loc = locale;
      if (page) {
        body.pid = page.pid;
        body.vid = page.vid;
        body.sku = page.sku;
      }
      if (platform) body.platform = platform;
      if (src) body.src = src;
      if (channel === "dm") {
        body.acct = accountId;
        if (utmCampaign) body.camp = utmCampaign;
        if (signed) {
          body.evt = eventId;
          body.zsig = signature;
        }
      }
      if (utmSource) body.utm_source = utmSource;
      if (utmMedium) body.utm_medium = utmMedium;
      if (utmCampaign) body.utm_campaign = utmCampaign;
      if (utmContent) body.utm_content = utmContent;
      body.ref = ref || null;
      return body;
    }

    function transmit(body) {
      var json = JSON.stringify(body);
      if (json.length > MAX_BODY_LENGTH) {
        ["utm_source", "utm_medium", "utm_campaign", "utm_content"].forEach(function (key) { delete body[key]; });
        json = JSON.stringify(body);
        // An extended arrival that still does not fit goes out as the plain v1 body: the extension never
        // costs an arrival.
        if (json.length > MAX_BODY_LENGTH && body.kind === "arrival") {
          json = JSON.stringify(v1(body));
        }
        if (json.length > MAX_BODY_LENGTH) return;
      }
      var queued = false;
      if (window.navigator && typeof window.navigator.sendBeacon === "function") {
        try {
          // A string body is sent as text/plain;charset=UTF-8 (the Blob it replaces sent the same type in
          // lower case; the worker lowercases it; CORS-safelisted, so no preflight) and is about 3x cheaper
          // to queue than a Blob, which matters inside a buy tap.
          queued = window.navigator.sendBeacon(ARRIVAL_ENDPOINT, json);
        } catch (_beaconError) {
          queued = false;
        }
      }
      if (!queued && typeof window.fetch === "function") {
        // no-cors POST keeps the Origin header only when a referrer policy other than no-referrer is used.
        var pending = window.fetch(ARRIVAL_ENDPOINT, {
          method: "POST",
          mode: "no-cors",
          headers: { "Content-Type": "text/plain;charset=UTF-8" },
          body: json,
          credentials: "omit",
          referrerPolicy: "strict-origin",
          keepalive: true
        });
        if (pending && typeof pending.catch === "function") pending.catch(function () {});
      }
    }

    function v1(body) {
      V2_FIELDS.forEach(function (key) { delete body[key]; });
      body.v = 1;
      return body;
    }

    // Decided on first use (the arrival at load + idle, or an earlier hide, leave or buy tap), never
    // before: same DM test as the v1 body. The first DM body is kept for the tap/return beacons (only its
    // DM ids are read), so a tap does not parse the URL again.
    function dmLid(body) {
      if (lid === "") {
        lid = null;
        body = body || buildBody();
        if (body.ch === "dm") {
          var bytes = window.crypto.getRandomValues(new window.Uint8Array(8));
          lid = Array.prototype.map.call(bytes, function (b) { return (b + 256).toString(16).slice(1); }).join("");
          dmBody = body;
        }
      }
      return lid;
    }

    function navEntry() {
      return window.performance.getEntriesByType("navigation")[0] || {};
    }

    // Milliseconds since navigation start; a prerendered page counts from its activation.
    function msSince(value, nav) {
      return value > 0 ? Math.max(0, Math.round(value - (nav.activationStart > 0 ? nav.activationStart : 0))) : null;
    }

    function extend(body, early) {
      var perf = window.performance;
      var nav = navEntry();
      var fcp = perf.getEntriesByName("first-contentful-paint")[0];
      var hero = document.querySelector('img[fetchpriority="high"]');
      var heroDone = Boolean(hero && hero.complete && hero.naturalWidth > 0);
      var heroEntry = heroDone && perf.getEntriesByName(hero.currentSrc || hero.src, "resource")[0];
      // v stays 1 (wire-compatible): kind:"arrival" plus a valid lid tells a new worker to read the rest.
      body.v = 1;
      body.kind = "arrival";
      body.lid = lid;
      // Not document.readyState: Chromium reports "complete" for a page that is left before its load event.
      var loaded = nav.loadEventStart === undefined ? document.readyState === "complete" : nav.loadEventStart > 0;
      body.stage = loaded ? "load" : heroDone ? "hero" : "dcl";
      body.t = {
        ttfb: msSince(nav.responseStart, nav),
        fcp: fcp ? msSince(fcp.startTime, nav) : null,
        hero: heroEntry ? msSince(heroEntry.responseEnd, nav) : null,
        dcl: msSince(nav.domContentLoadedEventStart, nav),
        load: msSince(nav.loadEventStart, nav)
      };
      body.left = early;
      // Only fresh navigations send an arrival (isFreshNavigation), so this is "navigate" or "prerender".
      body.nav = prerendered || nav.activationStart > 0 ? "prerender" : nav.type || "navigate";
    }

    function send(early) {
      if (sent) return;
      sent = true;
      try {
        var body = buildBody();
        try {
          if (dmLid(body)) extend(body, early === true);
        } catch (_extensionError) {
          v1(body);
        }
        transmit(body);
      } catch (_error) {
        // Arrival counting must never delay or interrupt the page or checkout.
      }
    }

    function leave() {
      send(true);
    }

    // Tap and return bodies carry only what the worker reads: the load id and the arrival's DM ids.
    function eventBody(kind, extra) {
      var body = { v: 2, kind: kind, lid: lid };
      TAP_FIELDS.forEach(function (key) {
        if (dmBody[key]) body[key] = dmBody[key];
      });
      for (var key in extra) body[key] = extra[key];
      return body;
    }

    // Capture phase, before the page's own handlers. Never prevents or delays the navigation.
    function onTap(event) {
      try {
        var target = event.target;
        var link = !tapAt && lid !== null && target && target.closest && target.closest(TAP_SELECTOR);
        if (!link || !dmLid()) return;
        tapAt = Date.now();
        var nav = navEntry();
        // The visitor is leaving for checkout. WebKit fires no pagehide for a page left before its load
        // event, so before load a still pending arrival goes out now (left:true) instead of being lost.
        // After load it has normally gone out already (load + idle); if not, pagehide sends it.
        if (!(nav.loadEventStart > 0)) leave();
        transmit(eventBody("tap", {
          ms: msSince(window.performance.now(), nav),
          target: link.closest("[data-gwp-sticky]") ? "sticky"
            : link.closest("[data-gwp-offer-box]") ? "offer"
              : link.closest('[data-cta-position="mobile-above-fold"]') ? "hero" : "other"
        }));
      } catch (_error) {
        // Tap counting must never delay or interrupt checkout.
      }
    }

    // Back from checkout into the page kept in the back/forward cache: count the return, re-arm the tap.
    function onPageShow(event) {
      try {
        if (!event.persisted || !tapAt) return;
        var body = eventBody("return", { sinceTapMs: Math.max(0, Date.now() - tapAt) });
        tapAt = 0;
        transmit(body);
      } catch (_error) {
        // Return counting must never interrupt the page.
      }
    }

    function isFreshNavigation() {
      var perf = window.performance;
      if (perf && typeof perf.getEntriesByType === "function") {
        var entries = perf.getEntriesByType("navigation");
        if (entries && entries.length > 0 && entries[0].type) return entries[0].type === "navigate";
      }
      if (perf && perf.navigation && typeof perf.navigation.type === "number") return perf.navigation.type === 0;
      return true;
    }

    // Every page, DM or not, sends at the v1 moment (load + idle), exactly as before the load-loss change:
    // a DM arrival with the load fields is built inside send() at that moment. send() treats only `true`
    // as early, so the IdleDeadline that requestIdleCallback passes to it is ignored.
    function sendWhenIdle() {
      if (typeof window.requestIdleCallback === "function") window.requestIdleCallback(send, { timeout: 3000 });
      else window.setTimeout(send, 1);
    }

    function arm() {
      try {
        if (document.prerendering) {
          prerendered = true;
          document.addEventListener("prerenderingchange", arm, { once: true });
          return;
        }
        if (sent || !isFreshNavigation()) return;
        captureIdentity();
        window.addEventListener("pagehide", leave);
        document.addEventListener("visibilitychange", function () {
          if (document.visibilityState === "hidden") leave();
        });
        document.addEventListener("click", onTap, true);
        window.addEventListener("pageshow", onPageShow);
        if (document.readyState === "complete") sendWhenIdle();
        else window.addEventListener("load", sendWhenIdle);
      } catch (_error) {
        // Arrival counting must never delay or interrupt the page or checkout.
      }
    }

    try {
      if ((window.Shopify && window.Shopify.designMode) || typeof window.URLSearchParams !== "function") return;
      if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", arm);
      else arm();
    } catch (_error) {
      // Arrival counting must never delay or interrupt the page or checkout.
    }
  })();
})();

